/**
 *  Copyright AlpineReplay Inc, 2021. All rights reserved.
 *  Authors: Slobodan Djordjevic
 */
import React from "react";
import {useSelector} from "react-redux";
import {useHistory} from "react-router-dom";
import {Element, Row, Label, Button, Icon, Tabs, Tab} from "trux";
import './GamePageHeader.css';

export const GamesPageHeader = () => {
  const history = useHistory()
  let team = useSelector(state => state.team.value);
  let divisions = useSelector(state => state.divisions.value);
  let isTeamLoggedIn = useSelector(state => state.isTeamLoggedIn);
  let user = useSelector(state => state.user.value);
  let year = new Date().getFullYear();

  const getDivisionId = () => {
    let divisionId = 0;
    if (divisions?.length > 0) {
      divisionId = divisions[0].division_id;
      if (team) {
        for (let d in divisions) {
          let div = divisions[d];
          for (let t in div.myTeams) {
            let tm = div.myTeams[t];
            if (tm.team_id === team.team_id) {
              divisionId = div.division_id;
              return divisionId;
            }
          }
        }
      }
    }
    return divisionId;
  }

  const showAdminMenu = () => {
    return !(getDivisionId() <= 0 || !isTeamLoggedIn || !user);
  }

  const goToSettings = () => {
    history.push(`/${team?.name}/settings`)
  }

  const goToAccount = () => {
    let divisionId = getDivisionId();
    let userId = user.user_id;
    history.push(`/${team.name}/settings/division/${divisionId}/staff/${userId}/edit`)
  }

  return (
    <Element className="game-page-header" marginBottom="6">
      <Element padding="8">
        <Row justifyContent="center">
          <Label
            type={Label.Type.Heading2}
            content={team?.title}
            className="team-title"
          />
        </Row>
        <Row justifyContent="center">
          {team &&
            <Label
              type={Label.Type.Body}
              bold
              content={team.players_gender === 'female' ? `Girls • ${team.players_birth_year}` : `Boys • ${team.players_birth_year}`}
            />
          }
        </Row>
        <Row justifyContent="center" marginTop="2">
          {showAdminMenu() &&
            <Button
              small
              onClick={goToSettings}
              marginRight="1"
              content={
                <Row alignItems="center">
                  <Icon size={16} type={Icon.Type.Settings} marginRight="2"/>
                  <Label type={Label.Type.InnerButton} content="Settings" />
                </Row>
              }>
            </Button>
          }

          {showAdminMenu() &&
            <Button
              small
              onClick={goToAccount}
              marginLeft="1"
              content={
                <Row alignItems="center">
                  <Icon size={16} type={Icon.Type.Profile} marginRight="2"/>
                  <Label type={Label.Type.InnerButton} content="Account" />
                </Row>
              }>
            </Button>
          }
        </Row>
      </Element>
      <Tabs className="tabs">
        <Tab
          trkAction="Games Tab Pressed"
          exact
          id="games"
          title={"Games"}
          span={1}
          icon={Icon.Type.Games}
          iconSize={16}
          toLocation={`/${team?.name}`}
        />
        <Tab
          trkAction="Roster Tab Pressed"
          exact
          id="roster"
          title={"Roster"}
          span={1}
          icon={Icon.Type.PlayersGeneric}
          iconSize={16}
          toLocation={`/${team?.name}/rosters/season/${year}`}
        />
      </Tabs>
    </Element>
  )
}